import { isObjectDeeplyChanged } from '../../util/state';
import { ErrorType } from './enum';
import { State } from './selector';

/**
 * Update flags for App Container
 */
export const getUpdateFlags = (newState: State, oldState: State) => {
    const {
        error,
        availableTariffs,
        selectedTariffId,
        isLoading,
        isContentEnabled,
        isFriendsAndFamily,
        isYoung,
        isAvailabilityChecked,
        isTVProductSelected,
        isGigakombi,
        isOverlayOpen,
    } = newState;
    const tariffChanged = isObjectDeeplyChanged(availableTariffs, oldState.availableTariffs);
    const availabilityChanged = isAvailabilityChecked !== oldState.isAvailabilityChecked;
    const errorChanged = error !== oldState.error;

    return {
        loading: isLoading !== oldState.isLoading || isOverlayOpen !== oldState.isOverlayOpen,
        tariffChanged,
        isInitError: errorChanged && (error?.type === ErrorType.CMS_CONFIG
            || error?.type === ErrorType.JARVIS),
        isAvcError: errorChanged && error?.type === ErrorType.AVC_ERROR,
        offerSummaryCard: selectedTariffId !== oldState.selectedTariffId
            || tariffChanged
            || isContentEnabled !== oldState.isContentEnabled
            || isTVProductSelected !== oldState.isTVProductSelected
            || isGigakombi !== oldState.isGigakombi
            || availabilityChanged,
        friendsAndFamily: isFriendsAndFamily !== oldState.isFriendsAndFamily,
        young: isYoung !== oldState.isYoung,
        tvProduct: isTVProductSelected !== oldState.isTVProductSelected,
        avc: availabilityChanged,
    };
};
